import React, { useState } from "react"
import { ButtonParts } from "~/components/atoms/ButtonParts"
import { Modal } from "react-bootstrap"
import { Api } from "~/api/Api";
import HtmlReactParser from "html-react-parser"

/*
    商品の選び方と料金についてボタン生成用コンポーネント
    props
        onClick:クリックイベント
 */

interface Props {
}

export function HowToButton(props: Props) {
  const [show, showSate] = useState<boolean>(false)
  const [element, setElement] = useState<string>("")

  const modalChange = async () => {
    if (!show) {
      const content = await Api.getHtmlData("payment-choice", "modal")
      const dom = new DOMParser()
      const html = dom.parseFromString(content, "text/html").getElementsByClassName("modal-content")[0].innerHTML
      setElement(html)
    }
    showSate(!show)
  }

  return (
    <>
      <ButtonParts
        action={modalChange}
        className={"text-link"}
      >
        商品の選び方と料金について
      </ButtonParts>

      <Modal className={"introduction-support-modal"} show={show} onHide={modalChange} size={"xl"}>
        {HtmlReactParser(element)}
        <Modal.Footer>
          <ButtonParts className={"btn btn-success"} action={modalChange}>閉じる</ButtonParts>
        </Modal.Footer>
      </Modal>
    </>
  )
}
